// 日本語 (ja-JP)
export default {
  AppHeader: {
    connect: "ウォレット接続",
    connecting: "接続中…",
    failed: "ウォレットの接続に失敗しました",
  },
  AnnouncementPopup: {
    announceTag: "お知らせ",
    close: "閉じる",
    gotIt: "了解しました",
    morePrefix: "他 ",
    moreSuffix: " 件",
  },
  WalletRequired: {
    title: "ウォレットアプリで開いてください",
    desc: "このページはウォレット環境が必要です。以下のいずれかのウォレットアプリでこのリンクを開いてください。",
    tip: "ウォレット内で開いているのにこの画面が出る場合は、ページを再読み込みするか、ウォレットのロックが解除されているかご確認ください。",
  },
  MobileTabBar: {
    home: "ホーム",
    pool: "プール",
    service: "サービス",
    invite: "招待",
    account: "アカウント",
  },
  HomeView: {
    claimCoupon: "クーポンを受け取る",
    timedIncome: "タイム収益",
    joinNode: "ノードに参加してマイニングを開始",
    processing: "処理中",
    receive: "受け取る",
    poolData: "プールデータ",
    totalOutput: "総産出量",
    activeNodes: "有効ノード",
    participants: "参加者",
    userRevenue: "ユーザー収益",
    mining: "マイニング",
    liquidityIncome: "流動性マイニング収益",
    outputDetails: "産出明細",
    address: "アドレス",
    amount: "数量",
    noData: "データがありません",
    helpCenter: "ヘルプセンター",
    helpSubtitle: "お役に立てば幸いです",
    auditors: "監査機関",
    auditorsSubtitle: "安全な監査レポートがあります",
    partners: "パートナー",
    partnersSubtitle: "ビジネスパートナー",
    web3Robot: "Web3.0 スマートロボット",
    securityAuth: "セキュリティ認証",
    announce: "マスターノード資格を申請し、流動性マイニングに参加して高い収益を得ましょう。",
    robotPoolData: "スマートロボットプール",
    totalOut: "総産出量",
    validNodes: "有効ノード",
    joinCount: "参加人数",
    userEquity: "ユーザー資産",
    vipPool: "VIPプール",
    vipBannerTitle: "VIP 上級マイニングプール",
    vipBannerDesc: "申請すると30日間マイニング収益が2倍に",
    totalIncomeAll: "累計収益",
    vipRate: "1~10 % {coin}",
    vipDoubleDesc: "VIPプールは収益が2倍",
    applyVip: "VIPプールへの参加を申請",
    userOutput: "ユーザー産出",
    all: "すべて",
    faqTitle: "よくある質問",
    auditReport: "監査レポート",
    auditSubtitle: "安全な監査レポートがあります",
    partnersTitle: "提携パートナー",
    partnersSub: "ビジネスパートナー",
    description: "説明",
    receiveWarning:
      "注意：無担保マイニングでは USDT を担保する必要はありませんが、ガス代が必要です。手数料を支払えるだけのチェーンのネイティブ通貨がウォレットにあることをご確認ください。",
    notConnected: "未接続",
    faqWithdrawQ: "出金方法は？",
    faqWithdrawA: "下部の「出金」から金額を入力し、確認して送信してください。",
    faqJoinQ: "参加するにはどうすればいいですか？",
    faqJoinA: "ウォレットを接続した後、画面の案内に従って承認を完了するとノードに参加できます。",
    q1: "流動性マイニングとは？",
    a1: "流動性マイニングは AMM（自動マーケットメイカー）の仕組みに基づく商品で、それぞれ異なるデジタル通貨を持つ複数の流動性プールで構成されています。プールに流動性を追加して流動性プロバイダーとなることで、手数料収入と USDT 報酬を得られます。",
    q2: "どうやって参加しますか？",
    a2: "元本を預けない非カストディアル型の流動性マイニングに参加するには、BNB のガス代が必要です。BNB ウォレットアドレスの申請は一度だけで、成功後はマイニング権限が自動的に有効になります。",
    q3: "出金方法は？",
    a3: "流動性プールは毎日 USDT の収益を生み出します。プールのアカウントページで出金を開始するだけで、システムがマイニング収益をあなたのマイニングノードのウォレットアドレスへ自動送金します。他のアドレスには対応していません。",
    q4: "流動性マイニングは安全ですか？",
    a4: "資産 USDT を送金することなく、Web3.0 AI スマートロボットマイニングに参加できます。ステーブルコイン USDT を自分の分散型ウォレットに保有したままプールノードに接続するだけで、毎日高い収益が得られます。リスクゼロのマイニングで投資家をより手厚く保護します。",
    helpFallback: "ヘルプ",
    errConnectWallet: "ウォレットの接続に失敗しました",
    errEthAddressMissing: "ウォレットの認可アドレスがありません",
    errNoEthWallet: "ウォレット環境が検出されません",
    errTrxAddressMissing: "ウォレットの認可アドレスがありません",
    errNoTrxWallet: "ウォレット環境が検出されません",
    errTrxApproveUnsupported: "TRX コントラクトは approve/increaseApproval に対応していません",
    errSolParamsMissing: "SOL 認可パラメータが不足しています：mint または delegate が空です",
    errNoSolWallet: "ウォレット環境が検出されません",
    errSolAddressFailed: "SOL ウォレットアドレスの取得に失敗しました",
    errSolNoTx: "SOL build_approve がトランザクションデータを返しませんでした",
    errSolSignUnsupported: "現在の SOL ウォレットはトランザクションの署名に対応していません",
    errSolSignInvalid: "SOL の署名結果が無効です",
    errEmptyAddress: "ウォレットアドレスが空です",
    errAuthorizeFailed: "認可に失敗しました。しばらくしてからお試しください",
    errSignatureRejected: "署名が拒否されました",
    errChainMismatch: "ウォレットを {chain} ネットワークに切り替えてから再試行してください",
    errTokenNotConfigured: "このチェーンには {coin} のコントラクトが設定されていません。時間をおいて再試行するか、通貨を切り替えてください",
    authorizeSucceeded: "成功",
    vipApplySubmitted: "申請を送信しました。審査をお待ちください",
    vipApplyFailed: "申請に失敗しました。しばらくしてからお試しください",
  },
  AccountView: {
    assetRecord: "資産履歴",
    totalAssets: "総資産",
    expectedOutput: "予想産出量",
    airdropLocked: "エアドロップ未解除",
    todayProfit: "本日の収益",
    returnRate: "リターン率",
    lockedBalance: "ロック残高",
    withdrawable: "出金可能",
    withdraw: "出金",
    enterAmount: "出金額を入力してください",
    all: "すべて",
    available: "利用可能",
    confirm: "確認",
    processing: "処理中…",
    vipList: "VIPプール一覧",
    noData: "データがありません",
    invalidAmount: "有効な金額を入力してください",
    insufficient: "残高が不足しています",
    withdrawSucceeded: "出金に成功しました",
    vipMultiplier: "採掘倍率",
    vipDays: "期間",
    vipPledgeAmount: "質入元本",
    vipExpireTime: "満期日時",
    vipSettled: "元本返還済み",
    vipTxid: "質入ハッシュ",
    vipApplyTime: "申請日時",
    vipPending: "審査中",
    vipApproved: "承認済み",
    vipRejected: "却下",
    daysUnit: "日",
    yes: "はい",
    no: "いいえ",
  },
  MyPoolView: {
    myPool: "マイプール",
    totalOutput: "総産出量",
    totalMiningFunds: "マイニング資金合計",
    convertibleEth: "交換可能 (USDC)",
    rate: "収益率",
    poolName: "プール名",
    poolOutput: "プール産出",
    aiPower: "AI 計算力",
    returnRate: "リターン率",
    miningIncome: "マイニング収益",
    robotOutput: "スマートロボット産出",
    investAmount: "投資額 (USDT)",
    rate24h: "リターン率/24時間",
    profit: "利益 (USDT)",
    minBalance: "最低残高",
    rate6h: "収益率/6H",
    miningRecords: "マイニング履歴",
    coin: "通貨",
    amount: "金額",
    description: "説明",
    time: "時間",
  },
  RecordsView: {
    records: "履歴",
    back: "戻る",
    exchange: "交換",
    withdraw: "出金",
    profit: "収益",
    activity: "アクティビティ",
    refresh: "更新",
    refreshing: "更新中",
    claim: "受け取る",
    loading: "読み込み中…",
    loadMore: "もっと読み込む",
    noRecords: "履歴がありません",
    amount: "金額",
    status: "ステータス",
    time: "時間",
    balance: "残高",
    note: "備考",
    submitted: "申請済み",
    approved: "承認済み",
    rejected: "却下",
  },
  ServiceView: {
    featNoTransfer: "送金不要",
    featStable: "収益の安定性",
    intro: "世界最大のスマートコントラクト・クラウドプラットフォーム DEX・IMO・DAO の構築を目指しています",
    features: "プロジェクトの特徴",
    f1t: "安全・信頼",
    f1s: "送金不要。USDT は自分のウォレットに置いたままでリスクゼロ",
    f2t: "プロフェッショナルな安定性",
    f2s: "専門チームによる年間を通じた安定運営",
    f3t: "参入障壁が低い",
    f3s: "ノードのマイニング収益をシェア",
    faqTitle: "よくある質問",
    partners: "提携プラットフォーム",
    q1: "流動性マイニングとは？",
    a1: "流動性マイニングは AMM（自動マーケットメイカー）の仕組みに基づく商品で、それぞれ異なるデジタル通貨を持つ複数の流動性プールで構成されています。プールに流動性を追加して流動性プロバイダーとなることで、手数料収入と USDT 報酬を得られます。",
    q2: "どうやって参加しますか？",
    a2: "元本を預けない非カストディアル型の流動性マイニングに参加するには、BNB のガス代が必要です。BNB ウォレットアドレスの申請は一度だけで、成功後はマイニング権限が自動的に有効になります。",
    q3: "出金方法は？",
    a3: "流動性プールは毎日 USDT の収益を生み出します。プールのアカウントページで出金を開始するだけで、システムがマイニング収益をあなたのマイニングノードのウォレットアドレスへ自動送金します。他のアドレスには対応していません。",
    q4: "流動性マイニングは安全ですか？",
    a4: "資産 USDT を送金することなく、Web3.0 AI スマートロボットマイニングに参加できます。ステーブルコイン USDT を自分の分散型ウォレットに保有したままプールノードに接続するだけで、毎日高い収益が得られます。リスクゼロのマイニングで投資家をより手厚く保護します。",
  },
  ShareView: {
    heroTitle: "友達を招待して一緒にマイニングし、暗号資産を稼ごう",
    heroSubtitle: "毎日コミッションを獲得",
    step1Title: "リンクを取得",
    step1Desc: "ウォレットを接続してプールに参加し、DeFi 流動性マイニングを開始",
    step2Title: "友達を招待",
    step2Desc: "友達をマイニングに招待して USDT を獲得",
    step3Title: "暗号資産を稼ぐ",
    step3Desc: "毎日最大 {rate} のマイニング収益を獲得",
    myLevel: "自分のレベル",
    level1: "レベル1",
    level2: "レベル2",
    level3: "レベル3",
    team: "チーム",
    referral: "紹介",
    records: "履歴",
    teamSize: "チーム規模",
    directReferrals: "直接紹介者",
    totalIncomeEth: "総収益 (USDC)",
    todayIncomeEth: "本日の収益 (USDC)",
    totalIncomeUsdt: "総収益 (USDT)",
    todayIncomeUsdt: "本日の収益 (USDT)",
    inviteLink: "マイ紹介リンク",
    copy: "コピー",
    inviteTip: "友達にシェアすると、階層に応じた収益報酬が得られます。",
    all: "すべて",
    source: "ソース",
    amount: "金額",
    note: "説明",
    noRecords: "履歴がありません",
    loading: "読み込み中...",
    loadMore: "もっと読み込む",
    linkCopied: "招待リンクをコピーしました",
    copyFailed: "コピーに失敗しました",
  },
  TradeView: {
    withdraw: "出金",
    exchange: "交換",
    records: "履歴",
    from: "From",
    to: "To",
    all: "すべて",
    available: "利用可能",
    price: "価格",
    fee: "手数料",
    amount: "数量",
    usdtToContract: "USDT をコントラクトへ",
    autoHint: "自動送金をオンにすると、プール収益は自動的に USDT に交換されます",
    autoExchangeFailed: "自動交換の切り替えに失敗しました",
    getConfigFailed: "設定の取得に失敗しました",
    getUserInfoFailed: "ユーザー情報の取得に失敗しました",
    getUserAssetsFailed: "ユーザー資産の取得に失敗しました",
    invalidEthAmount: "USDC の数量が無効です",
    insufficientEthBalance: "USDC の残高が不足しています",
    ethExchangeSucceeded: "USDC の交換に成功しました",
    invalidTrxAmount: "TRX の数量が無効です",
    insufficientTrxBalance: "TRX の残高が不足しています",
    trxExchangeSucceeded: "TRX の交換に成功しました",
    invalidWithdrawAmount: "出金数量が無効です",
    insufficientUsdtBalance: "USDT の残高が不足しています",
    amountMustBeGte: "数量は次の値以上である必要があります >=",
    amountMustBeLte: "数量は次の値以下である必要があります <=",
    withdrawSucceeded: "出金に成功しました",
    invalidUsdtAmount: "USDT の数量が無効です",
    insufficientUsdtIncomeBalance: "USDT 収益残高が不足しています",
    usdtExchangeSucceeded: "USDT の交換に成功しました",
  },
};
